var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 16,
    viewBox: "0 0 230 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 230,
    height: 15,
    rx: 7.5,
    fill: "url(#paint0_linear_1610_19929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1610_19929",
    x1: 8.38192,
    y1: -0.750017,
    x2: 221.608,
    y2: 1.49808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#736E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8F7651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A87D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#F5CAA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#EFE0BF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralColor);
export default __webpack_public_path__ + "static/media/neutralColor.7e4cb309fbb740159edaac8728901746.svg";
export { ForwardRef as ReactComponent };